/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import carouselMixin from "./mixins/carousel-mixin";

const componentName = "colors-feed";

export default baustein.register(componentName, {
    componentName,
    mixins: [carouselMixin]
});

